import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { updatejob,getJobDetail } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import { Multiselect } from 'multiselect-react-dropdown';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class Editjob extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      job:[],
      salary_range_forthisjob: 15000,
      organisation_place:'',
      organisation:'',
      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true
    }

    this.job_id = this.props.match.params.id;

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getJobDetail = this.getJobDetail.bind(this); 

  }
 

  
  getJobDetail(){

    let req = JSON.stringify({
        job_id:this.job_id
    });

    getJobDetail(req).then((response) => {
      
        if(response.status==1){
            this.setState({
                job_title : response.detail.job_title,
                salary_range_forthisjob :response.detail.salary_range_forthisjob,
                job_category: response.detail.job_category,
                job_description: response.detail.job_description,
                job_gender:response.detail.job_gender,
                organisation:response.detail.organisation,
                open_date: response.detail.open_date,
                closing_date: response.detail.closing_date,
                job_location: response.detail.job_location,
                joining:response.detail.joining,
                salary_range_forthisjob: response.detail.salary_range_forthisjob,
                language_preferred: response.detail.language_preferred,
                expected_qualification: response.detail.expected_qualification,
                skillsrequired: response.detail.skillsrequired,
                job_role: response.detail.job_role,
                job_subject_teaching: response.detail.job_subject_teaching,
                job_experience: response.detail.job_experience,
                examcertifications: response.detail.examcertifications,
                expected_qualification_other: response.detail.expected_qualification_other,
                skillsrequired_other: response.detail.skillsrequired_other,
                job_role_other: response.detail.job_role_other,
                job_subject_teaching_other: response.detail.job_subject_teaching_other,
                examcertifications_other: response.detail.examcertifications_other
            });     
        }
        else{
            this.setState({job:[]});
        }


    })


  }

  componentDidMount() {

          var THIS = this;
          this.getJobDetail();    
  }


  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };


  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{

    var auth_data = JSON.parse(localStorage.getItem("user_data"));

    let req = JSON.stringify({
        job_id:this.job_id,
        user_id:1,
        job_title: this.state.job_title,
        job_category: this.state.job_category,
        job_description: this.state.job_description,
        job_gender:this.state.job_gender,
        organisation:this.state.organisation,
        open_date: this.state.open_date,
        closing_date: this.state.closing_date,
        job_location: this.state.job_location,
        joining: this.state.joining,
        salary_range_forthisjob: this.state.salary_range_forthisjob,
        language_preferred: this.state.language_preferred,
        expected_qualification: this.state.expected_qualification,
        skillsrequired: this.state.skillsrequired,
        job_role: this.state.job_role,
        job_subject_teaching: this.state.job_subject_teaching,
        job_experience: this.state.job_experience,
        examcertifications: this.state.examcertifications,
        expected_qualification_other: this.state.expected_qualification_other,
        skillsrequired_other: this.state.skillsrequired_other,
        job_role_other: this.state.job_role_other,
        job_subject_teaching_other: this.state.job_subject_teaching_other,
        examcertifications_other: this.state.examcertifications_other

    })
    
    updatejob(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Posted job successfully', 'Post a job');

      }else{
            
        NotificationManager.error('Error posting a job', 'Post a job');
      }

    });
}
  
onSelect = (selectedList) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    language_preferred: keywords.toString(),
  });
}
onRemove = (selectedList, removedItem) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    language_preferred: keywords.toString(),
  });
}

onSelectExpectedQualification = (selectedList) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    expected_qualification: keywords.toString(),
  });
}

onRemoveExpQualification = (selectedList, removedItem) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    expected_qualification: keywords.toString(),
  });
}


onSelectExamCertificaitons = (selectedList) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    examcertifications: keywords.toString(),
  });
}
onRemoveExamCertifications = (selectedList, removedItem) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    examcertifications: keywords.toString(),
  });
}

onSelectSkillRequired = (selectedList) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    skillsrequired: keywords.toString(),
  });
}
onRemoveSkillRequired = (selectedList, removedItem) => {
  let keywords = [];
  selectedList.map((item, i) => {
    keywords.push(item)
  });
  this.setState({
    skillsrequired: keywords.toString(),
  });
}

 
  render() {
 const {value, suggestions, pickedones} = this.state;
 const { salary_range_forthisjob, vertical } = this.state
    const horizontalLabels = {
      12000: '12k',
      400000: '4L'
    }

    const {job} = this.state;

    const formatkg = value => value;

    const expected_qualification_arr = [
      "Graduate in Education (BA / B.SC etc.)",
      "Post Graduate (MA /M.Sc etc)",
      "Engeneering Graduate",
      "Diploma In Education",
      "Bachelors Degree in Education (B.Ed)",
      "Masters Degree in Education (M.Ed)",
      "Doctorate (Phd)",
      "Bachelor of Elementray Education (B.EL.Ed)",
      "Bachelor of Arts & Education (BA. B.Ed)",
      "Diploma in Elementary Education (D.EL.Ed)",
      "Bachelor of Physical Education (B.P.Ed)",
      "Master of Philosophy in Education (M.Phil)",
      "Bachelor of Library Science (B.Lib)",
      "Bachelor of Library & Information Sciences (B.Lib.I.Sc)",
      "Masters in Library & Information Sciences (M.Lib.I.Sc)",
      "Bachelor of Fine Arts (BFA)",
      "Diploma Program in Special Education (DESCE-MR / DSE / MRW / DHLS etc)",
      "Post Graduate Diploma in Special Education",
      "Graduate in Special Education  (B.Ed - Spl Education)",
      "Other"];

const language_preferred_arr = [ 
'English',
'Hindi',
'Tamil',
'Kannada',
'Telugu',
'Urdhu',
'Malayalam'
];

const examcertifications_arr = [
  "None",
  "Central Teachers Eligibliity Test (CTET)",
  "National Eligibility Test (NET / UGC-NET)",
  "Basic Training Certificates",
  "Primary Teachers Certificates",
  "Teachers Training Certificates",
  "Teacher Eligiblity Test (TET)",
  "State Teachers Eligiblity Test (STET)",
  "Certificate course in Library Sciences",
  "Certificate course in Drawing teacher training",
  "Certificate in Care giving program",
  "Certificate program in Special Education",
  "Certicate Courses in Dance",
  "Certicate Courses in Arts",
  "Certificate Courses in Sports",
  "Certificate Courses in Music & Dance",
  "Other"];

const skillsrequired_arr = [
  "Expertise in specific subjects of teaching",
  "Written and verbal communication",
  "Ability to adapt to different situations",
  "Knowledge of teaching software and tools",
  "Ability to teach students experiencing challenge with learning",
  "Time management skills",
  "Innovative training strategies",
  "Flexibility to modify training principles",
  "Classroom management",
  "Leadership",
  "Conflict management",
  "Collaborative & Interpersonal skills",
  "Creative",
  "Financial Management",
  "Human Resource Management",
  "Curriculam Development",
  "School Policy Knowledge",
  "Understanding & Implementation of NEP requirements",
  "Other"];

  const language_preferred =  this.state.language_preferred ? this.state.language_preferred.split(","):[];
  const examcertifications = this.state.examcertifications ? this.state.examcertifications.split(","):[];
  const expected_qualification = this.state.expected_qualification ? this.state.expected_qualification.split(","):[];
  const skillsrequired = this.state.skillsrequired ? this.state.skillsrequired.split(","):[];

        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                  <h4 class="card-title">Job - Add</h4>
                 
                  <div class="postajobform wc">


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Organisation </label>
<input type="text" class="form-control forminputcls" id="organisation" name="organisation"  value={this.state.organisation}  onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job title </label>
<input type="text" class="form-control forminputcls" id="job_title" name="job_title" value={this.state.job_title}  onChange={this.handleChange}/>
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Job Description </label>
<textarea class="form-control forminputcls" name="job_description" id="job_description" value={this.state.job_description}  placeholder="Description" rows="10" onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job role</label>
<select name="job_role" class="formselectinputcls"  value={this.state.job_role}  onChange={this.handleChange}> 
            <option value="">Select Role</option>
            <option value="Pre Primary Teacher">Pre Primary Teacher</option>
            <option value="Primary Teacher">Primary Teacher</option>
            <option value="Secondary Teacher">Secondary Teacher</option>
            <option value="Senior Secondary Teacher">Senior Secondary Teacher</option>
            <option value="Special Educator">Special Educator</option>
            <option value="Libraian">Libraian</option>
            <option value="Physial Education Teacher">Physial Education Teacher</option>
            <option value="Counsellor">Counsellor</option>
            <option value="Administrator">Administrator</option>
            <option value="Accountant">Accountant</option>
            <option value="Marketing">Marketing</option>
            <option value="Music / Dance Teacher">Music / Dance Teacher</option>
            <option value="Other">Other</option>
</select>
</div> 
<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job Role - If Other </label>
<input type="text" class="form-control forminputcls" id="job_role_other" value={this.state.job_role_other} disabled={this.state.job_role_other_disabled} name="job_role_other"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Role Type</label>
<select name="job_category" class="formselectinputcls" value={this.state.job_category} onChange={this.handleChange}> 
            <option value="">Select Role Type</option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
            <option value="Contractual">Contractual</option>
            <option value="Temporary">Temporary</option>
            <option value="Internship">Internship</option>
</select>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Subject Of Teaching</label>
<select name="job_subject_teaching" class="formselectinputcls"  value={this.state.job_subject_teaching} onChange={this.handleChange}> 
            <option value="">Select Subject</option>
            <option value="Biology">Biology</option>
            <option value="Science">Science</option>
            <option value="Maths">Maths</option>
            <option value="Physics">Physics</option>
            <option value="Chemistry">Chemistry</option>
            <option value="Art">Art</option>
            <option value="History">History</option>
            <option value="Economics">Economics</option>
            <option value="Computer Science">Computer Science</option>
            <option value="Phyisical Education">Phyisical Education</option>
            <option value="Librarian">Librarian</option>
            <option value="Humanities">Humanities</option>
            <option value="Geography">Geography</option>
            <option value="Civics">Civics</option>
            <option value="English">English</option>
            <option value="Hindi">Hindi</option>
            <option value="Tamil">Tamil</option>
            <option value="Kannada">Kannada</option>
            <option value="Telugu">Telugu</option>
            <option value="Marathi">Marathi</option>
            <option value="French">French</option>
            <option value="Spanish">Spanish</option>
            <option value="German">German</option>
            <option value="Reglion and Religious Studies">Reglion and Religious Studies</option>
            <option value="Visual Arts">Visual Arts</option>
            <option value="Robotics & Coding">Robotics & Coding</option>
            <option value="Other">Other</option>
</select>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Subject Of Teaching - If Other </label>
<input type="text" class="form-control forminputcls" id="job_subject_teaching_other" disabled={this.state.job_subject_teaching_other_disabled} name="job_subject_teaching_other"   onChange={this.handleChange}/>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Experience Required </label>
<select name="job_experience" class="formselectinputcls" value={this.state.job_experience}  onChange={this.handleChange}> 
            <option value="">---Select---</option>
            <option value="freshers">Freshers</option>
            <option value="1-3">1-3 Years</option>
            <option value="4-9">4-5 years</option>
            <option value="10-15">10-15 years</option>
            <option value="15+">15+ years</option>
        </select>
</div> 
 
<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Anticipated joining </label>
<select name="joining" class="formselectinputcls" value={this.state.joining} onChange={this.handleChange}> 
            <option value="">---Select---</option>
            <option value="Immediate">Immediate</option>
            <option value="15 Days">15 Days</option>
            <option value="1 month">1 month</option>
            <option value="2 months">2 months</option>
            <option value="3 months">3 months</option>
        
        </select>
</div> 

<div class="formgroup">
<label for="exampleInputPassword1">Job Opening Date </label>

<input type="date" class="form-control forminputcls" id="open_date" name="open_date" value={this.state.open_date}  onChange={this.handleChange}/>


</div> 
<div class="formgroup">
<label for="exampleInputPassword1">Job Closing Date </label>

<input type="date" class="form-control forminputcls" id="closing_date" name="closing_date" value={this.state.closing_date}  onChange={this.handleChange}/>


</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Job Location </label>
 
        <select name="job_location" class="formselectinputcls" value={this.state.job_location}  onChange={this.handleChange}>

            <option value="">Select</option>
            <option value="In Campus">In Campus</option>
            <option value="Hybrid">Hybrid</option>
            <option value="Remote">Remote</option>
        </select>
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Salary Range for this Job</label> <div id="salaryText" class="salaryText">
    &#8377; {formatkg(salary_range_forthisjob)}
</div>
<Slider
    min={10000}
    max={400000}
    value={this.state.salary_range_forthisjob}
    labels={horizontalLabels}
    format={formatkg}
    step={1000}
    handleLabel={this.state.salary_range_forthisjob}
    onChange={this.handleChangeHorizontal}
    />
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Languages preferred </label>

          <Multiselect
            className="formselectinputcls"
            isObject={false}
            selectedValues={language_preferred}
            options={language_preferred_arr} // Options to display in the dropdown
            onSelect={this.onSelect} // Function will trigger on select event
            onRemove={this.onRemove} // Function will trigger on remove event
          />
 
       
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Expected Qualification </label>

            <Multiselect
            className="formselectinputcls"
            isObject={false}
            selectedValues={expected_qualification}
            options={expected_qualification_arr} // Options to display in the dropdown
            onSelect={this.onSelectExpectedQualification} // Function will trigger on select event
            onRemove={this.onRemoveExpQualification} // Function will trigger on remove event
            />
 
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Expected Qualification - If Other </label>
<input type="text" class="form-control forminputcls" id="expected_qualification_other" name="expected_qualification_other" disabled={this.state.expected_qualification_other_disabled}  onChange={this.handleChange}/>
</div> 


<div class="formgroup">
<label for="exampleInputPassword1">Entrance Examination & Certifications Required  </label>

          <Multiselect
            className="formselectinputcls"
            isObject={false}
            selectedValues={examcertifications}
            options={examcertifications_arr} // Options to display in the dropdown
            onSelect={this.onSelectExamCertificaitons} // Function will trigger on select event
            onRemove={this.onRemoveExamCertifications} // Function will trigger on remove event
          />
 
</div> 


<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Examination and Certifications - If Other </label>
<input type="text" class="form-control forminputcls" id="examcertifications_other" name="examcertifications_other" disabled={this.state.examcertifications_other_disabled}  onChange={this.handleChange}/>
</div> 



<div class="formgroup">
<label for="exampleInputPassword1">Skills required </label>

          <Multiselect
            className="formselectinputcls"
            isObject={false}
            selectedValues={skillsrequired}
            options={skillsrequired_arr} // Options to display in the dropdown
            onSelect={this.onSelectSkillRequired} // Function will trigger on select event
            onRemove={this.onRemoveSkillRequired} // Function will trigger on remove event
          />

 
</div>

              <div class="formgroup end_date_option" id="end_date_option">
              <label for="exampleInputPassword1">Skills required - If Other </label>
              <input type="text" class="form-control forminputcls" id="skillsrequired_other"  value={this.state.skillsrequired_other}  name="skillsrequired_other" disabled={this.state.skillsrequired_other_disabled}  onChange={this.handleChange}/>
              </div> 

               

              {this.state.auth_data.login_id==1 &&  
              <div>
              <div class="formgroup">
              <label for="exampleInputPassword1">Job Approval </label>
              <select name="job_approval" class="formselectinputcls" value={this.state.job_approval} onChange={this.handleChange}>
                          <option value="">Select status</option>
                          <option value="0">Reject</option>
                          <option value="1">Approve</option>
                          <option value="2">On-Hold</option>
              </select>
              </div>
              
              </div>

              }

              <div class="formgroup text-center paddingtop20">
                <button type="button" name="postajob" class="btn-main" onClick={this.handleSubmit}>Update Job</button>
              </div> 
                    </div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Editjob;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/editjob.jsx